import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { MainHeroProps } from '@comfama/comfama-ui-react';
import transformBreadcrumb from '../../../../utils/transformBreadcrumb';

function mainHeroAdapter(data: any): MainHeroProps {
    return {
        title: data.tituloPrincipal ? data.tituloPrincipal : '',
        description: data.descripcion ? documentToPlainTextString(JSON.parse(data.descripcion.raw)) : '',
        img: data.imagenHeader ? data.imagenHeader.file.url : '',
        imgPosition: data.botonCompartir ?? 'right',
        imgBackground: data.imagenBackground ? data.imagenBackground[0].file.url : '',
        backgroundColor: data.tituloBoton ?? '',
        breadcrumbItems: data.migaDePan ? transformBreadcrumb(data.migaDePan) : [],
        ctaAction: data.redireccionBoton ? data.redireccionBoton : '',
        ctaLabel: data.tituloBoton ? data.tituloBoton : 'Conocer más'
    };
}

export default mainHeroAdapter;
